import { useEffect, useState } from "react";

import { useNavigate, useSearchParams } from "react-router-dom";

import ExitLearningModal from "../ExitLearningModal";

import InclusiveEducationVideo from "./InclusiveEducationVideo";

import { useGetInclusiveEducationContent } from "./queries";

import {
  CHAPTER_COMPLETE_PERCENTAGE,
  LMS_CHAPTER_ID,
  LMS_COURSE_ID,
  LMS_COURSE_NAME,
  LMS_MODULE_ID,
  POST_CHAPTER_ASSESSMENT,
} from "../../../../utils/cookiesmanager";

import InclusiveEducation from "./InclusiveEducation";
import { useSaveInclusiveContent } from "./mutation";

import styles from "./styles.module.scss";

const InclusiveContent = () => {
  const [searchParams] = useSearchParams();

  const [showInclusiveContent, setShowShowInclusiveContent] = useState(false);
  const [allowLeave, setAllowLeave] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const navigate = useNavigate();

  const courseId =
    searchParams.get("courseId") || localStorage.getItem(LMS_COURSE_ID);
  const chapterId =
    searchParams.get("chapterId") || localStorage.getItem(LMS_CHAPTER_ID);
  const moduleId =
    searchParams.get("moduleId") || localStorage.getItem(LMS_MODULE_ID);
  const courseName =
    searchParams.get("courseName") || localStorage.getItem(LMS_COURSE_NAME);
  const chapterPostAssessment = Number(localStorage.getItem(POST_CHAPTER_ASSESSMENT));
    

  const languageId = localStorage.getItem("l_id") || 1;

  const {
    data: inclusiveEducationContent,
    isLoading,
    isFetching,
  } = useGetInclusiveEducationContent({
    chapterId,
    courseId,
    languageId,
    moduleId,
  });

  const { response } = inclusiveEducationContent?.data || {};

  const videoData = response?.videos?.[0];

  const videoStatus = videoData?.videoStatus;

  const texts = response?.texts || [];

  const totalParts = inclusiveEducationContent?.data?.response?.totalContent;

  const { mutate: saveProgress, isPending } = useSaveInclusiveContent();

  useEffect(() => {
    // Add a dummy history entry
    window.history.pushState(
      { guard: true },
      "",
      `${window.location.pathname}?${searchParams.toString()}`,
    );

    const handlePopState = () => {
      if (!allowLeave) {
        setShowWarning(true);

        // Re-push state to stop navigation
        window.history.pushState({ guard: true }, "", window.location.pathname);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [allowLeave]);

  const handleBackClick = () => {
    setShowWarning(true);
  };

  const handleContinueLearning = () => {
    setShowWarning(false);
    setAllowLeave(false);
  };

  const handleExit = () => {
    navigate(
      `/user/chapter-list?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`,
    );
  };

  const handleContinue = () => {
  const hasVideo = response?.videos?.length > 0;
  const hasText = response?.texts?.length > 0;
  const chapterPercentage = localStorage.getItem(CHAPTER_COMPLETE_PERCENTAGE);

  if (hasText && videoStatus === 1) {
    setShowShowInclusiveContent(true);
    return;
  }

  if (hasVideo && !hasText && chapterPostAssessment === 1) {
    navigate(
      `/user/post-chapter-assessment?courseId=${courseId}&moduleId=${moduleId}&chapterId=${chapterId}&courseName=${courseName}`
    );
    return;
  }

  if (videoStatus === 1 && chapterPostAssessment === 0) {
    navigate(
      `/user/chapter-list?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`
    );
    return;
  }

  if (videoStatus === 1 || chapterPercentage === "100%") {
    setShowShowInclusiveContent(true);
    return;
  }

  saveProgress(
      {
        courseId,
        moduleId,
        chapterId,
        totalParts: totalParts || 1,
        part: 1,
      },
      {
        onSuccess: () => {
          if(chapterPostAssessment === 0){
            navigate(
      `/user/chapter-list?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`
    );
    return;
          }
          setShowShowInclusiveContent(true);
        },
        onError: (error) => {
          console.error("Progress update failed", error);
        },
      },
    );
  };

  useEffect(()=>{
    if(response && Object.keys(response)?.length>0){
      const hasVideo = response?.videos?.length > 0;
      const hasText = response?.texts?.length > 0;

      if(!hasVideo && hasText )
        {
          setShowShowInclusiveContent(true)
          return;
        }
        if(!hasVideo && !hasText && chapterPostAssessment === 1 )
        {
         navigate(
      `/user/post-chapter-assessment?courseId=${courseId}&moduleId=${moduleId}&chapterId=${chapterId}&courseName=${courseName}`
    );
    return;
        }
        if(!hasVideo && !hasText && chapterPostAssessment === 0 )
        {
        navigate(
      `/user/chapter-list?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`
    );
    return;
        }
    }
  },[response])

  return (
    <div className={styles["inclusive-content"]}>
      {showInclusiveContent ? (
        <InclusiveEducation
          inclusiveEducationContent={inclusiveEducationContent}
          handleContinueLearning={handleContinueLearning}
          handleBackClick={handleBackClick}
          isLoading={isLoading}
          setShowShowInclusiveContent={setShowShowInclusiveContent}
        />
      ) : (
        <InclusiveEducationVideo
          inclusiveEducationContent={inclusiveEducationContent}
          isLoading={isLoading}
          handleClick={handleContinue}
          handleContinueLearning={handleContinueLearning}
          handleBackClick={handleBackClick}
          isPending={isPending}
          isFetching={isFetching}
        />
      )}
      {showWarning && (
        <ExitLearningModal
          handleContinueLearning={handleContinueLearning}
          handleExit={handleExit}
          show={showWarning}
        />
      )}
    </div>
  );
};

export default InclusiveContent;
